<script>
import { mapActions } from 'vuex';

export default {

  props: {
    selectedSurveyID: {
      type: Number,
      required: true,
    },
  },
  
  data() {
    return {      
      series: [],
      hoveredElement: null,

      // DOM //

      gridHeight: 0,
      gridWidth: 0,
    }
  },
  
  mounted() {
    this._getMaterialityMatrixData();
  },


  methods: {
    
    ...mapActions('results', [
      'getMaterialityMatrixData',
    ]),

    _getMaterialityMatrixData() {
      const params = {
        su2_survey_id: this.selectedSurveyID, //this.selectedSurveyID,
        company_id: parseInt(this.$user.company_id), //parseInt(localStorage.company_id),
        created_by: parseInt(this.$user.user_id), //parseInt(localStorage.user_id),
        is_deleted: false,
        is_approved: true,
      };
      this.getMaterialityMatrixData(params)
        .then( res => {
          this.series = res.data;
        })
        .catch( error => {
          console.error(error);
        })

    },

    // events // 

    onHoverElement(id) {
      this.hoveredElement = id;
    },
    onMouseLeaveElement() {
      this.hoveredElement = null;
    },

    // utility functions //

    getColor(id){
      if(id==1){
        return '#fa8a14'
      }
      if(id==2){
        return '#44a900'
      }
      if(id==3){
        return '#de0222'
      }
      if(id==4){
        return '#004578'
      }
    },
    getColorConditionally(item){
      if ( item.id == this.hoveredElement ) {
        return this.getColor(item.category_id);
      } else {
        return 'black';
      }
    },
    getFontWeightConditionally(item){
      if ( item.id == this.hoveredElement ) {
        return 'bold';
      } else {
        return 'normal';
      }
    },
  },
}
</script>

<template>
  <div class="graph-container">
    <span class="title">{{ $t("su2Results.resultsPage.graph.materialityAnalysis") }}</span>
    <div class="materiality-matrix">
      <div class="bar left-bar">
        <div class="bar-text bar-indicator">{{ $t("su2Results.resultsPage.graph.highImpact") }}</div>
        <div class="bar-text bar-header">{{ $t("su2Results.resultsPage.graph.external") }}</div>
      </div>
      <div class="bar bottom-bar">
        <div class="bar-text bar-header">{{ $t("su2Results.resultsPage.graph.internal") }}</div>
        <div class="bar-text bar-indicator">{{ $t("su2Results.resultsPage.graph.highImportance") }}</div>
      </div>

      <div class="graph-sectors" id="grid">
        <div class="grid">
          <div class="top">
            <div class="sector sector-1"></div>
            <div class="sector sector-2"></div>
          </div>

          <div class="bottom">
            <div class="sector sector-3"></div>
            <div class="sector sector-4"></div>
          </div>


          <div v-for="(item, index) in series" :key="index"
            class="data-bubble"
            :id="item.id"
            :style="{bottom: `${item.data[1]*20 }%`, left: `${item.data[0]*20}%`, backgroundColor: getColor(item.category_id)}"
            
            @mouseover="onHoverElement(item.id)"
            @mouseleave="onMouseLeaveElement()"
          >
            {{ index + 1}}
          </div>

        </div>
      </div>

    </div>

  </div>
</template>


<style lang="scss" scoped>

  .graph-container {
    font-size: 12px;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    height: 100%;
    width: 100%;

    & > .title {
      position: absolute;
      top: .5em;
      left: 0;
      right: 0;
      text-align: center;
      font-size: 1.5em;
      font-weight: bold;
      color: var(--sustainfinity-navy);
    }
  }

  .materiality-matrix {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;

    
    box-shadow: 0 0 5px 1px lightgray;

    flex: .55;

    height: 300px;
    width: 300px;

    min-height: 300px;
    min-width: 300px;

    background-color: var(--sustainfinity-faded-blue);

    &> .graph-sectors {

      padding-left: 2em;
      padding-bottom: 2em;

      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      align-content: center;
      flex: 1;

      height: 100%;
      width: 100%;

      &> .grid {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: center;
        flex: 1;

        height: 100%;
        width: 100%;

        background: rgba(255, 255, 255, 0.35);
        background-image: url("/images/sustainfinity-bg-img.png");
        background-size: 80% 80%;
        background-position: center;
        background-repeat: no-repeat;
        &> .top {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: stretch;
          align-content: stretch;
          
          flex: .5;
          width: 100%;
          height: 50%;
          
          .sector {
            display: flex;
            flex-direction: column;
            flex: 1;
          }
        
        }
        &> .bottom {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: stretch;
          align-content: stretch;
        
          flex: .5;
          width: 100%;
          height: 50%;
        
          .sector {
            display: flex;
            flex-direction: column;
            flex: 1;
          }
        }

        .data-bubble {
          position: absolute;
          z-index: 2;
          border-radius: 100%;

          display: flex;
          justify-content: center;
          align-items: center;
          align-content: center;
          text-align: center;
          padding: .1em;

          opacity: .75;
          color: white;
          // font-weight: bold;
          font-size: .7em;

          width: 1rem;
          height: 1rem;

          border: thin solid var(--sustainfinity-navy);

          cursor: default;
          &:hover {
            scale: 1.15;
            opacity: 1;
            z-index: 99999;
          }
        }
      }
    }

    &> .bar {
      position: absolute;
      z-index: 1;
      background-color: #2d4f76;
      font-size: .7em;
      color: white;
    }

    &> .left-bar {
      left: 0;
      top: 0;
      width: 2em;
      height: 100%;

      padding-top: 1.5em;
      padding-left: .25em;

      &> .bar-text {
        writing-mode: vertical-lr;
        transform: rotate(180deg);

        padding-top: 50px;
      }

    }

    &> .bottom-bar {
      right: 0;
      bottom: 0;
      width: 100%;
      height: 2em;

      display: flex;
      flex-direction: row;
      justify-content: flex-end;

      padding-right: 1em;

      &> .bar-header {
        padding-right: 50%;
        transform: translateX(50%);
      }
    }
  }

  .legend {
    flex: .45;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    padding: 1em;
  }

  .legend-item {
    margin-left: 1em;

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    text-align: left;

    // font-weight: bold;

    > .legend-text {
      padding-left: .66em;
      padding-bottom: .33em;
    }
  }

  .sector {
    opacity: .9;
  }
  .sector-1 {
    background-color: #edf6fd;
  }
  .sector-2 {
    background-color: #edd8dd;
  }
  .sector-3 {
    background-color: #f0f6e7;
  }
  .sector-4 {
    background-color: #edf6fd;
  }


</style>